import { set } from '@/utils/vuex'
export default {
  setFirstName: set('firstName'),
  setLastName: set('lastName'),
  setDisplayName: set('displayName'),
  setEmail: set('email'),
  setLogged: set('isLogged'),
  setCredentials: set('credentials')
}
